const ARTICLE = "(?:the|this|that|an?|another|current)";
const SUBJECT_VERBS = [
  "has", "have", "had", "is", "was", "are", "were", "still", "could", "can", "cannot", "may", "might", "will",
  "did", "does", "returns", "returned", "accepts", "accepted", "rejected", "refused", "created", "reports",
  "says",
];
const VENDOR_NOUNS = [
  "employee", "customer", "provider", "location", "tutor", "appointment", "service", "setup", "settings",
  "rota", "schedule", "admin", "webhook", "booking", "identity", "connection", "api", "calendar",
];
const PRECEDING_WORDS = ["in", "check", "recheck", "inspect", "sent to", "from", "into"];

const FOLLOWING = new RegExp(`^(?:${[...SUBJECT_VERBS, ...VENDOR_NOUNS].join("|")})\\b`, "i");
const PRECEDING = new RegExp(`(?:^|[^\\w])(?:${PRECEDING_WORDS.join("|")})\\s+$`, "i");
const VENDOR_PATTERN = new RegExp(
  `(?:\\b(${ARTICLE})\\s+)?\\bAmelia(?:(’|')s)?\\b`,
  "gi",
);

/**
 * Replace the booking vendor's name in text shown to staff. Only the vendor
 * usages the Hub and booking service produce are rewritten ("in Amelia",
 * "Amelia's admin", "Amelia has no ...", "an Amelia employee"); a name that
 * is followed by a capitalised word is a person ("Amelia Jones") and so is
 * any other use that cannot be shown to be the vendor.
 */
export function bookingSystemDisplayText(detail: string): string {
  return detail.replace(
    VENDOR_PATTERN,
    (match: string, article: string | undefined, possessive: string | undefined, offset: number, whole: string) => {
      // Matching is case-insensitive only so the article can start a sentence;
      // the name itself must be written "Amelia".
      const nameStart = offset + match.length - "Amelia".length - (possessive ? possessive.length + 1 : 0);
      if (whole.slice(nameStart, nameStart + "Amelia".length) !== "Amelia") return match;
      const rest = whole.slice(offset + match.length);
      if (/^\s+[A-Z][a-z]/.test(rest) && !possessive) return match;
      if (possessive && /^\s+[A-Z]/.test(rest)) return match;
      const before = whole.slice(0, offset);
      const vendor = article !== undefined
        || PRECEDING.test(before)
        || (/^\s/.test(rest) && FOLLOWING.test(rest.trimStart()));
      if (!vendor) return match;
      const sentenceStart = offset === 0 || /[.!?]\s+$/.test(before);
      let phrase: string;
      if (article) {
        const lower = article.toLowerCase();
        const word = lower === "an" || lower === "a" ? "a" : lower;
        phrase = `${word} booking system`;
        if (/^[A-Z]/.test(article)) phrase = `${phrase[0]!.toUpperCase()}${phrase.slice(1)}`;
        else if (sentenceStart) phrase = `${phrase[0]!.toUpperCase()}${phrase.slice(1)}`;
      } else {
        phrase = sentenceStart ? "The booking system" : "the booking system";
      }
      return possessive ? `${phrase}${possessive}s` : phrase;
    },
  );
}
